import React from "react";
import { object } from "prop-types";
import Select, { components } from "react-select";
import "./select.css";
import { optionsType } from "../../../prop-types";
import { LegalEntityIcon, NaturalPersonIcon } from "../../../assets";

const getValue = (options, field) => {
  if (!options) {
    return "";
  }

  return options.filter((option) =>
    Array.isArray(field.value)
      ? field.value.indexOf(option.value) >= 0
      : field.value === option.value
  );
};

const SelectForClientType = ({
  targetTypeCategory,
  options,
  field,
  form: { setFieldValue },
  menuIsOpen,
  ...props
}) => {
  const value = getValue(options, field);

  const handleChange = (option) => {
    if (!option) {
      return setFieldValue(field.name, null);
    }
    const newValue = Array.isArray(option.value)
      ? option.map((item) => item.value)
      : option.value;

    return setFieldValue(field.name, newValue);
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: value.length ? "#DBFFED" : "#ffffff",
      boxShadow: state.isFocused ? null : null,
      borderColor: state.isFocused ? "#0AD172" : "#C7C7C7",
      borderRadius: 4,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? "#DBFFED" : "#ffffff",
        borderBottom: "1px solid #C7C7C7",
        "&:hover": {
          backgroundColor: "#DBFFED",
        },
      };
    },
    menu: (provided) => ({
      ...provided,
      margin: 0,
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
      minWidth: "100%",
      width: "fit-content",
    }),

    valueContainer: (styles) => ({
      ...styles,
      paddingLeft: 8,
      paddingRight: 0,
      opacity: value && value.length ? 1 : 0.8,
    }),

    singleValue: (styles) => ({
      ...styles,
      paddingLeft: 22,
      paddingRight: 4,
      top: 17,
    }),
    placeholder: (styles) => ({
      ...styles,
      paddingLeft: 22,
      top: 17,
      marginRight: 20,
      width: "90%",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      "& div": {
        // to get child
        paddingLeft: 0,
      },
    }),
  };
  const ValueContainer = ({ children, ...props }) => {
    return (
      <components.ValueContainer {...props}>
        {targetTypeCategory.toLowerCase() === "person" ? (
          <NaturalPersonIcon width={16} height={16} />
        ) : (
          <LegalEntityIcon width={16} height={16} />
        )}

        {children}
      </components.ValueContainer>
    );
  };

  return (
    <Select
      menuIsOpen={menuIsOpen}
      components={{
        IndicatorSeparator: () => null,
        ValueContainer: ValueContainer,
      }}
      {...props}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        backgroundColor: "red",
        colors: {
          ...theme.colors,
          primary25: "#FFFFFF",
          primary: "#0AD172",
          primary50: "#DBFFED",
          neutral10: "red",
        },
      })}
      styles={customStyles}
      className={"dropdown-group"}
      options={options}
      name={field.name}
      value={value}
      onChange={handleChange}
      onBlur={field.onBlur}
    />
  );
};

SelectForClientType.propTypes = {
  options: optionsType.isRequired,
  form: object.isRequired,
  field: object.isRequired,
};

export default SelectForClientType;



// WEBPACK FOOTER //
// ./src/components/formik/SelectForClientType/SelectForClientType.jsx